import clsx from 'clsx';
import styles from './Avatar.module.css';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps {
  name: string;
  color: string;
  size?: AvatarSize;
  src?: string;
  className?: string;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2);
  return `${parts[0][0]}${parts[parts.length - 1][0]}`;
}

export function Avatar({ name, color, size = 'md', src, className }: AvatarProps) {
  const initials = getInitials(name);

  return (
    <span
      className={clsx(styles.avatar, styles[size], className)}
      style={{
        backgroundColor: `color-mix(in srgb, ${color} 22%, var(--surface))`,
        color,
      }}
      title={name}
      aria-label={name}
      role="img"
    >
      {src ? (
        <img className={styles.image} src={src} alt={name} />
      ) : (
        initials
      )}
    </span>
  );
}
